import tripService from './ws';

export default tripService;